// Entry point for math worksheets page
import { initializeUI, generateWorksheet } from '../ui.js';
import { initLanguagePicker } from '../language.js';
import { initSupportDrawer } from '../support.js';

// Make generateWorksheet globally available for the onclick handler
window.generateWorksheet = generateWorksheet;

// Initialize everything when the document is loaded
document.addEventListener('DOMContentLoaded', () => {
    // Initialize all UI components
    initializeUI();
    initLanguagePicker();
    initSupportDrawer();
});

// Export for potential module usage
export { generateWorksheet };